import { BizAppConfig } from 'config/application.manifest';
import { createOpenPlatformRequest } from '@/services/request';

export interface OpenPlatformTokenResult {
  accessToken: string;
}

const OPEN_PLATFORM_API_BASE =
  process.env.UMI_APP_OPEN_PLATFORM_URL?.trim() ||
  BizAppConfig.appOpenPlatformUrl?.trim() ||
  process.env.UMI_APP_AUTH_BFF_URL ||
  '';

const request = createOpenPlatformRequest(OPEN_PLATFORM_API_BASE);

export function getOpenPlatformToken() {
  return request<OpenPlatformTokenResult>('/bff/open-platform/token', {
    method: 'GET',
  });
}
